// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gv-z","response":"hv-z","error":"iv-z","disabled":"jv-z","buttons":"kv-z","feedbackQuestionSection":"lv-z","yesNoWrapper":"mv-z"};